export function exhaustiveCheck(value: never): never {
  throw new Error(`Should not be reached: ${value}`);
}
